import { mostSearchesProdData } from './most-searches-procedures-prod';
import { mostSearchesTestData } from './most-searches-procedures-test';

import { EnvironmentNameEnum, getEnvironmentName } from '@/config/environment';
import { MostSearchedResultType } from '@/types/most-search-type';

export function getMostSearches(): MostSearchedResultType[] {
  const env = getEnvironmentName();
  return [EnvironmentNameEnum.PRODUCTION, EnvironmentNameEnum.HOMOLOG].includes(env)
    ? mostSearchesProdData
    : mostSearchesTestData;
}
